import BaseModel from "./BaseModel";

export default class WatchableValue<T extends any> extends BaseModel {
  public get className(): string {
    return "WatchableValue"; // no itx
  }

  get isPersistent(): boolean {
    return false;
  }

  _value: T;

  constructor(value: T, name?: string) {
    super();
    this._value = value;
    if (name) {
      this.name = name;
    }
  }

  set value(v: T) {
    if (this._value != v) {
      this._value = v;
      this.raiseOnUpdateUi();
    }
  }

  get value(): T {
    return this._value;
  }

  waitForChange(): Promise<any> {
    return new Promise((resolve, reject) => {
      const h = this.onChange.subscribe(() => {
        this.onChange.unsubscribe(h);
        resolve(this.value);
      });
    });
  }
}
